import { connect } from 'react-redux';
import Overview from '../../../components/front/overview/Overview';
import { getAllMarkets } from '../../../service/stocks';
import {
    changeMarket,
    changeRank,
    reloadRanks,
    resetRanks,
    showAll,
} from '../../../actions/overview';

function mapStateToProps({ overview }) {
    const state = {
        limit: overview.limit,
        currentRank: overview.currentRank,
        error: overview.error,
        reloading: overview.reloading,
        selectedMarket: overview.selectedMarket,
        markets: getAllMarkets(),
    };

    return state;
}

const mapDispatchToProps = {
    changeMarket,
    changeRank,
    reloadRanks,
    resetRanks,
    showAll,
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);



/** WEBPACK FOOTER **
 ** /src/shared/containers/front/overview/Overview.js
 **/